export function trackingUnpackGroup(packed: string): string[] | undefined {
  if (!/^[\w-]+$/.test(packed)) {
    return undefined;
  }

  const base64 = packed.replaceAll("-", "+").replaceAll("_", "/");
  const padded = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    "=",
  );

  let binary: string;
  try {
    binary = atob(padded);
  } catch {
    return undefined;
  }

  if (binary.length === 0 || binary.length % 16 !== 0) {
    return undefined;
  }

  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  const hex = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");

  const trackingIds: string[] = [];
  for (let offset = 0; offset < hex.length; offset += 32) {
    const digits = hex.slice(offset, offset + 32);
    trackingIds.push(
      [
        digits.slice(0, 8),
        digits.slice(8, 12),
        digits.slice(12, 16),
        digits.slice(16, 20),
        digits.slice(20, 32),
      ].join("-"),
    );
  }

  return trackingIds;
}
